import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    console.log("nested-form controller connected", {
      hasContainer: this.hasContainerTarget,
      hasTemplate: this.hasTemplateTarget
    })
  }

  add(event) {
    event.preventDefault()
    console.log("nested-form add() called")

    const template = this.templateTarget
    const content = template.content.cloneNode(true)
    // Collision-proof AND numeric: Rails strong params only accept nested
    // rows whose key is all digits (/\A-?\d+\z/), so UUIDs are silently
    // dropped. A page-global monotonic counter (shared with track-upload,
    // seeded by the clock) can never mint the same key twice, even for
    // several rows in one millisecond.
    const index = window.__nestedRowIndex = Math.max(Date.now(), (window.__nestedRowIndex || 0) + 1)

    // Replace NEW_RECORD placeholders
    const tempDiv = document.createElement("div")
    tempDiv.appendChild(content)
    tempDiv.innerHTML = tempDiv.innerHTML.replace(/NEW_RECORD/g, index)

    // firstElementChild, NOT firstChild: the template starts with a
    // whitespace text node, and appending that instead of the row made this
    // button a silent no-op (unmasked when the pre-built row was removed).
    this.containerTarget.appendChild(tempDiv.firstElementChild)
    console.log("nested-form add() completed - new row appended")
  }

  remove(event) {
    event.preventDefault()
    console.log("nested-form remove() called")

    const wrapper = event.target.closest("[data-nested-form-wrapper]")
    if (!wrapper) {
      console.log("nested-form remove() - no wrapper found")
      return
    }

    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      console.log("nested-form remove() - marking for destruction")
      destroyInput.value = "1"
      wrapper.style.display = "none"
      // A row marked for destruction must not participate in drag-reorder payloads
      wrapper.removeAttribute("data-sortable-id")
    } else {
      console.log("nested-form remove() - removing from DOM")
      wrapper.remove()
    }
  }
}
